import { HandleReturnItemChange } from 'components/Orders/Order';
import Flex from 'components/ui/Flex';
import { ReturnItem, ReturnOrderLine } from 'returnCenter-api';
import { useState } from 'react';
import { styled } from 'styled-components';
import Select from 'react-select';
import { CellInputRefs } from 'hooks/useKeyboardNavigation';

type RefundCellProps = {
    item: ReturnItem;
    itemId?: number | string;
    splits?: ReturnItem[];
    handleReturnItemChange: HandleReturnItemChange;
    orderline?: ReturnOrderLine;
    disabled?: boolean;
    rowIndex?: string | number;
    colIndex?: string | number;
    cellInputRefs?: CellInputRefs;
    handleArrowKeyDown: (e: any, orderId: any, rowIndex: any, colIndex: any) => void;
    cellRefPrefix?: string;
};

const RefundCell = ({
    item,
    itemId,
    handleReturnItemChange,
    orderline,
    rowIndex,
    colIndex,
    cellInputRefs,
    handleArrowKeyDown,
    cellRefPrefix = '',
    disabled = false,
}: RefundCellProps) => {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <Flex column gap="0.5rem" className="refund-wrapper" $grow={1}>
            <StyledSelect
                isDisabled={disabled}
                data-percentage
                data-row={rowIndex}
                data-row-cell={colIndex}
                data-item-id={itemId}
                key={itemId}
                menuIsOpen={menuOpen}
                onMenuOpen={() => setMenuOpen(true)}
                onMenuClose={() => setMenuOpen(false)}
                ref={(el) => {
                    const key = `${cellRefPrefix}${rowIndex}-${colIndex}`;
                    if (cellInputRefs) cellInputRefs.current[key] = el;
                }}
                defaultValue={percentageOptions[4]}
                value={percentageOptions.find(
                    (option) => option.value === (item.percent ?? percentageOptions[4].value),
                )}
                onChange={(selectedOption) => {
                    const { value } = selectedOption as {
                        value: number;
                        label: string;
                    };
                    handleReturnItemChange(
                        orderline?.orderNumber ?? '',
                        orderline?.sku ?? '',
                        orderline?.orderLineNumber ?? '',
                        itemId ?? -1,
                        'percent',
                        value ?? 1.0,
                    );
                    setMenuOpen(false);
                }}
                options={percentageOptions}
                menuPortalTarget={document.body}
                tabIndex={-1}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' && !menuOpen) {
                        e.preventDefault();
                        e.stopPropagation();
                        setMenuOpen(true);
                        return;
                    }
                    if (e.key === 'Escape' && menuOpen) {
                        e.preventDefault();
                        e.stopPropagation();
                        setMenuOpen(false);
                        return;
                    }
                    // Only handle arrow navigation when menu is closed
                    if (!menuOpen) {
                        handleArrowKeyDown(e, itemId, rowIndex, colIndex);
                    }
                }}
            />
        </Flex>
    );
};

export default RefundCell;

export const percentageOptions = [
    { value: 0, label: '0%' },
    { value: 0.25, label: '25%' },
    { value: 0.5, label: '50%' },
    { value: 0.75, label: '75%' },
    { value: 1.0, label: '100%' },
];

export const StyledSelect = styled(Select)`
    display: flex;
    min-width: 0;
    flex: 1;
    height: 37px;
    white-space: nowrap;

    > * {
        width: auto !important;
        min-width: 100% !important;
    }
`;
